import { render, staticRenderFns } from "./MediaImagePreview.vue?vue&type=template&id=4158f4e3&scoped=true&"
import script from "./MediaImagePreview.vue?vue&type=script&lang=js&"
export * from "./MediaImagePreview.vue?vue&type=script&lang=js&"
import style0 from "./MediaImagePreview.vue?vue&type=style&index=0&id=4158f4e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4158f4e3",
  null
  
)

export default component.exports